import React, { useState } from 'react';
import './Sale.css';

export default function Sale() {
  const [showModal, setShowModal] = useState(false);

  /* ——— helpers ——— */
  const openModal  = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  /* full‑fat desktop / modal body (single source‑of‑truth) */
  const details = (
    <>
      <h2 className="sale__headline">Opening Sale</h2>
      <h3 className='josefin'>
        Any custom diamond ring with&nbsp;up&nbsp;to&nbsp;2.0 ct diamonds for a&nbsp;
        <strong>FIXED&nbsp;PRICE&nbsp;of&nbsp;£1499!</strong>
      </h3>

      <p>
        Purchase a bespoke diamond ring, designed to your taste, with a total
        diamond weight of 2.0 ct for just £1499!
      </p>

      <ul className="sale__list">
        <li>All diamonds VS–VVS, any desired shape, total weight up to 2.0 ct.</li>
        <li>Choice of 14 ct yellow or white gold. Upgrade to 18 ct gold for £75.</li>
        <li>
          Complementary matching travel ring (moissanite &amp; silver).  
          Gold plating available for £50.
        </li>
        <li>IGI Certificates provided for diamonds.</li>
        <li>Only 20 % deposit required.</li>
        <li>
          Free home delivery or optional £30 personal appointment in London for
          collection with size checking, letting you inspect your ring before
          final payment.
        </li>
        <li>Lead time of only 4 weeks from deposit to door.</li>
        <li>Flexible interest‑free payment options available.</li>
      </ul>

      <p>
        For custom requests not covered above, please set an appointment below
        and let us know your specifications.
      </p>
    </>
  );

  /* ——— render ——— */
  return (
    <>
      {/* ▸ DESKTOP: original content, unchanged */}
      <div className="sale__content phone-hide">
        {details}
      </div>

      {/* ▸ MOBILE: short summary + button */}
      <div className="phone-only sale__summary ">
        <h2 className="sale__headline sale__headline--small">Opening Sale</h2>
        <p className="sale__summary-text">
          Any bespoke diamond ring &nbsp;|&nbsp; up to 2 ct VVS diamonds  
          &nbsp;|&nbsp; fixed&nbsp;£1499&nbsp;.&nbsp; 20 % deposit.  
          Free matching travel ring.
        </p>
        <button className="btn btn--sale" onClick={openModal}>
          More&nbsp;Details
        </button>
      </div>

      {/* ▸ MOBILE MODAL: scrollable overlay */}
      {showModal && (
        <div className="sale-modal-overlay phone-only" onClick={closeModal}>
          <div
            className="sale-modal"
            onClick={e => e.stopPropagation()} /* keep clicks inside */
          >
            <button
              className="sale-modal__close"
              onClick={closeModal}
              aria-label="Close details"
            >
              &times;
            </button>

            <div className="sale-modal__content">
              {details}

              <p className="sale-modal__tnc">
                *Price shown includes VAT and applies to new orders placed
                before&nbsp;31&nbsp;May&nbsp;2025.&nbsp;One offer per customer.
                20 % deposit becomes non-refundable once CAD design is
                approved.&nbsp;Normal warranty applies.
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
